module.exports = __webpack_public_path__ + "img/logo.0251bc50.png";